angular
  .module("contrattoConvenzionamento.components", [])
  .component("contrattoConvenzionamento", {
    templateUrl:
      "ng/components/contrattoConvenzionamento/contrattoConvenzionamento.html",
    bindings: {
      configSearch: "<",
      vendorManag: "<",
      gestioneFornitori: "<",
      appCustomer: "<",
    },
    controller: ContrattoConvenzionamentoController,
    controllerAs: "contrattoConvCtrl",
  });

function ContrattoConvenzionamentoController(
  FileUploader,
  $configService,
  $rootScope,
  $simulationService,
  $timeout,
  $financialService
) {
  var self = this;

  self.loadingStatus = {
    uploading: false,
    loadingDataFromCerved: false,
    savedDataFromCerved: false,
    loading: false,
    loadingAddressesList: false,
    loadingPfList: false,
    insertingContract: false,
  };

  self.$onInit = function () {
    self.contractToUpload = {
      nameFile: null,
      uploading: null,
      uploaded: null,
    };
    self.firmatario = {
      nome: null,
      cognome: null,
      cf: null,
    };
    if (
      self.gestioneFornitori &&
      self.gestioneFornitori.contrattoConvenzionamento
    ) {
      self.firmatario =
        self.gestioneFornitori.contrattoConvenzionamento.firmatario;
      if (self.gestioneFornitori.contrattoConvenzionamento.fileName) {
        self.documentUploaded = {
          selected: false,
          nameFile: self.gestioneFornitori.contrattoConvenzionamento.fileName,
        };
        self.uuid = self.gestioneFornitori.contrattoConvenzionamento.uuid;
      }
      if (self.gestioneFornitori.contrattoConvenzionamento.filenameDocRic) {
        self.documentoIdFirmato = {
          selected: false,
          nameFile:
            self.gestioneFornitori.contrattoConvenzionamento.filenameDocRic,
        };
        self.uuidDocRic =
          self.gestioneFornitori.contrattoConvenzionamento.uuidDocRic;
      }
    } else if (
      self.appCustomer &&
      self.appCustomer.metadata &&
      self.appCustomer.metadata.riUserF
    ) {
      self.firmatario = self.appCustomer.metadata.riUserF;
    }
    self.ndgUser = self.gestioneFornitori.informazioni.metadata.riUserG.ndg;
  };

  self.handleChange = function (value, property) {
    if (self.firmatario) {
      self.firmatario[property] = value;
      self.gestioneFornitori.contrattoConvenzionamento.firmatario =
        self.firmatario;
    }
  };

  /** UPLOADER **/
  self.uploadDataFunc = function (index, uploadType) {
    self.fileIndex = index;
    self.uploadType = uploadType;
  };

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    var url;
    if (self.uploadType == "ContractConvenzionamento") {
      url =
        $configService.getAppConfig().url +
        "/simulator/upload/vendorManagement/service-infos/" +
        encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
        "/CONV/?token=" +
        $configService.getToken();
    } else if (self.uploadType == "IdConvenzionamento") {
      url =
        $configService.getAppConfig().url +
        "/simulator/upload/vendorManagement/service-infos/" +
        encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
        "/920/?token=" +
        $configService.getToken();
    }
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    self.uploader.uploadAll();
  };

  self.downloadContrattoConv = function (filename) {
    return (
      $configService.getAppConfig().url +
      "/simulator/download/service-infos/" +
      encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
      "/CONV" +
      "/" +
      encodeURIComponent(filename) +
      "/?token=" +
      $configService.getAppConfig().token
    );
  };

  self.downloadDocumentoId = function () {
    return (
      $configService.getAppConfig().url +
      "/simulator/downloadFromAlbagreen/service-infos/" +
      encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
      "/920" +
      "/" +
      encodeURIComponent(
        self.uuidDocRic ||
        self.gestioneFornitori.contrattoConvenzionamento.uuidDocRic
      ) +
      "/?token=" +
      $configService.getAppConfig().token
    );
  };

  self.uploader.onWhenAddingFileFailed = function (
    item /*{File|FileLikeObject}*/,
    filter,
    options
  ) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      $("#input-upload-" + self.fileIndex).val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".p7m") > -1
    ) {
      if (self.fileIndex == 1) {
        self.uploader.queue[0].progress = 100;
        self.visualProgBar1 = true;
        $timeout(function () {
          self.progresso1 = 100;
        }, 50);
        $timeout(function () {
          self.visualProgBar1 = false;
        }, 4000);
        return;
      }
      self.uploader.queue[0].progress = 100;
      self.visualProgBar = true;
      $timeout(function () {
        self.progresso = 100;
      }, 50);
      $timeout(function () {
        self.visualProgBar = false;
      }, 4000);
    } else {
      fileItem.remove();
      $("#input-upload-" + self.fileIndex).val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload();
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function () {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });
    fileItem.remove();
    $("#input-upload-" + self.fileIndex).val("");
  };

  self.uploader.onCancelItem = function (
    fileItem,
    response,
    status,
    headers
  ) { };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (response.success) {
      jQuery("#uploadInput_" + self.uploadType).val("");
      console.log(fileItem);
      if (self.uploadType == "ContractConvenzionamento") {
        self.uuid = response.uuid;
        self.documentUploaded = {
          selected: false,
          nameFile: response.fileName,
        };
        self.gestioneFornitori.contrattoConvenzionamento.uuid = response.uuid;
        self.gestioneFornitori.contrattoConvenzionamento.fileName =
          response.fileName;
      } else if (self.uploadType == "IdConvenzionamento") {
        self.uuidDocRic = response.uuid;
        self.documentoIdFirmato = {
          selected: false,
          nameFile: response.fileName,
        };
        self.gestioneFornitori.contrattoConvenzionamento.uuidDocRic =
          response.uuid;
        self.gestioneFornitori.contrattoConvenzionamento.filenameDocRic =
          response.fileName;
      }
    }
    self.uploader.queue = [];
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  /** FINE UPLOADER */

  self.check = function (el) {
    el.selected = !el.selected;
  };

  self.print = function () {
    self.loaderPrint = true;
    $simulationService
      .printCtrConvenzione(self.appCustomer, "STUBBED")
      .then(function (response) {
        if (response) {
          self.contractPrinted = true;
        }
        self.loaderPrint = false;
      })
      .catch(function (error) {
        console.log(error);
        self.loaderPrint = false;
      });
  };

  self.deleteDocument = function () {
    self.progresso = 100;
    self.visualProgBar = true;
    $timeout(function () {
      self.progresso = 0;
    }, 200);
    $timeout(function () {
      self.visualProgBar = false;
    }, 4000);
    self.documentUploaded = {};
    self.gestioneFornitori.contrattoConvenzionamento.fileName = null;
  };

  self.eraseDocumentFromAlbagreen = function () {
    self.progresso1 = 100;
    self.visualProgBar1 = true;
    $financialService
      .eraseDocumentFromAlbagreen(
        "soggetto",
        self.appCustomer.metadata.riUserG.ndg,
        self.uuidDocRic
      )
      .then(function (response) {
        if (response.success) {
          self.documentoIdFirmato = {};
          self.gestioneFornitori.contrattoConvenzionamento.filenameDocRic =
            null;
          self.gestioneFornitori.contrattoConvenzionamento.uuidDocRic = null;
        }
        $timeout(function () {
          self.progresso1 = 0;
        }, 200);
        $timeout(function () {
          self.visualProgBar1 = false;
        }, 4000);
      })
      .catch(function (error) {
        $timeout(function () {
          self.progresso1 = 0;
        }, 200);
        $timeout(function () {
          self.visualProgBar1 = false;
        }, 4000);
        console.log("ERROR: ", error);
      });
  };

  self.confirmContract = function () {
    self.confirmContractPending = true;
    $simulationService
      .saveContrattoConvenzionamento(
        self.firmatario,
        self.ndgUser,
        "CONV",
        self.documentUploaded.nameFile,
        self.gestioneFornitori.idOperation,
        self.uuidDocRic,
        self.gestioneFornitori.contrattoConvenzionamento.filenameDocRic
      )
      .then(function (response) {
        console.log(response);
        self.confirmContractPending = false;
        if (response.success) {
          $rootScope.$broadcast("addAlert", {
            text: "INSER_CRT_CNV_OK",
          });
          self.gestioneFornitori.contrattoConvenzionamento.verificato =
            response.verificato;
          self.gestioneFornitori.contrattoConvenzionamento.utente =
            response.utente;
          self.gestioneFornitori.contrattoConvenzionamento.dataConferma =
            response.dataConferma;
        }
      })
      .catch(function (error) {
        console.log(error);
        self.confirmContractPending = false;
      });
  };

  self.enableButton = function () {
    if (self.vendorManag.isStandard) {
      var test =
        self.firmatario &&
        !!self.firmatario.nome &&
        !!self.firmatario.cognome &&
        !!self.firmatario.cf &&
        self.documentoIdFirmato &&
        self.documentoIdFirmato.nameFile;
    } else {
      var test =
        self.firmatario &&
        !!self.firmatario.nome &&
        !!self.firmatario.cognome &&
        !!self.firmatario.cf &&
        self.documentUploaded &&
        self.documentUploaded.nameFile &&
        self.documentoIdFirmato &&
        self.documentoIdFirmato.nameFile;
    }
    return test;
  };
}